/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosActivityListInfo } from '../models/AptosActivityListInfo';
import type { AptosAnalyticsChartInfo } from '../models/AptosAnalyticsChartInfo';
import type { AptosCollectionDetailInfo } from '../models/AptosCollectionDetailInfo';
import type { AptosCollectionListInfo } from '../models/AptosCollectionListInfo';
import type { AptosHighlightCollectionInfo } from '../models/AptosHighlightCollectionInfo';
import type { AptosHolderListInfo } from '../models/AptosHolderListInfo';
import type { AptosMarketplaceInfo } from '../models/AptosMarketplaceInfo';
import type { AptosMarketplaceOverviewInfo } from '../models/AptosMarketplaceOverviewInfo';
import type { AptosMetadataUpdateRequest } from '../models/AptosMetadataUpdateRequest';
import type { AptosTokenActionListInfo } from '../models/AptosTokenActionListInfo';
import type { AptosTokenDetailInfo } from '../models/AptosTokenDetailInfo';
import type { AptosTokenListInfo } from '../models/AptosTokenListInfo';
import type { AptosTokenMetaDataDetailInfo } from '../models/AptosTokenMetaDataDetailInfo';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosNftControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateMetadata({
        requestBody,
    }: {
        requestBody: AptosMetadataUpdateRequest,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/aptos/nft/collection/token/metadata/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AptosTokenActionListInfo OK
     * @throws ApiError
     */
    public getTokenActionList1(): CancelablePromise<AptosTokenActionListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/token/action/list',
        });
    }

    /**
     * @returns AptosMarketplaceOverviewInfo OK
     * @throws ApiError
     */
    public getAptosMarketplaceList({
        period = 'D7',
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
    }): CancelablePromise<AptosMarketplaceOverviewInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/marketplace/list',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns AptosMarketplaceInfo OK
     * @throws ApiError
     */
    public getAptosMarketplaceInfo(): CancelablePromise<Array<AptosMarketplaceInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/marketplace/category/list',
        });
    }

    /**
     * @returns AptosCollectionDetailInfo OK
     * @throws ApiError
     */
    public getAptosCollectionDetail({
        collectionId,
    }: {
        collectionId: string,
    }): CancelablePromise<AptosCollectionDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection',
            query: {
                'collectionId': collectionId,
            },
        });
    }

    /**
     * @returns AptosTrxListInfo OK
     * @throws ApiError
     */
    public getAptosCollectionTransactionList({
        collectionId,
        stime,
        etime,
        from = '',
        to = '',
        fn = '',
        samt,
        eamt,
        page = 1,
        size = 25,
    }: {
        collectionId: string,
        stime?: number,
        etime?: number,
        from?: string,
        to?: string,
        fn?: string,
        samt?: number,
        eamt?: number,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/transaction/list',
            query: {
                'collectionId': collectionId,
                'stime': stime,
                'etime': etime,
                'from': from,
                'to': to,
                'fn': fn,
                'samt': samt,
                'eamt': eamt,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosTokenDetailInfo OK
     * @throws ApiError
     */
    public getAptosTokenDetail({
        tokenId,
    }: {
        tokenId: string,
    }): CancelablePromise<AptosTokenDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/token',
            query: {
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns AptosTrxListInfo OK
     * @throws ApiError
     */
    public getAptosTokenTransactionList({
        tokenId,
        stime,
        etime,
        from = '',
        to = '',
        fn = '',
        samt,
        eamt,
        page = 1,
        size = 25,
    }: {
        tokenId: string,
        stime?: number,
        etime?: number,
        from?: string,
        to?: string,
        fn?: string,
        samt?: number,
        eamt?: number,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/token/transaction/list',
            query: {
                'tokenId': tokenId,
                'stime': stime,
                'etime': etime,
                'from': from,
                'to': to,
                'fn': fn,
                'samt': samt,
                'eamt': eamt,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosTokenMetaDataDetailInfo OK
     * @throws ApiError
     */
    public getTokenMetaData({
        tokenId,
    }: {
        tokenId: string,
    }): CancelablePromise<AptosTokenMetaDataDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/token/metadata',
            query: {
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns AptosTokenListInfo OK
     * @throws ApiError
     */
    public getAptosTokenList({
        collectionId,
        page = 1,
        size = 25,
    }: {
        collectionId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosTokenListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/token/list',
            query: {
                'collectionId': collectionId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosHolderListInfo OK
     * @throws ApiError
     */
    public getAptosTokenHolderList({
        tokenId,
        page = 1,
        size = 25,
    }: {
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/token/holder/list',
            query: {
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosActivityListInfo OK
     * @throws ApiError
     */
    public getAptosTokenActivityList({
        tokenId,
        actionTypes,
        stime,
        etime,
        from = '',
        to = '',
        marketplaces,
        page = 1,
        size = 25,
    }: {
        tokenId: string,
        actionTypes?: Array<'MINT' | 'BURN' | 'TRANSFER' | 'MUTATE' | 'BIDDING' | 'CANCEL_BIDDING' | 'COLLECTION_BIDDING' | 'COLLECTION_CANCEL_BIDDING' | 'LISTING' | 'DELIST' | 'SOLD' | 'UPDATE_PRICE'>,
        stime?: number,
        etime?: number,
        from?: string,
        to?: string,
        marketplaces?: Array<string>,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/token/activity/list',
            query: {
                'tokenId': tokenId,
                'actionTypes': actionTypes,
                'stime': stime,
                'etime': etime,
                'from': from,
                'to': to,
                'marketplaces': marketplaces,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosCollectionListInfo OK
     * @throws ApiError
     */
    public getAptosCollectionList({
        sortField = 'VOLUME',
        sortDirection = 'DESC',
        period = 'D7',
        page = 1,
        size = 25,
    }: {
        sortField?: 'NAME' | 'PRICE' | 'VOLUME' | 'VOLUME_CHANGE' | 'HOLDER' | 'ITEM',
        sortDirection?: 'ASC' | 'DESC',
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
        page?: number,
        size?: number,
    }): CancelablePromise<AptosCollectionListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/list',
            query: {
                'sortField': sortField,
                'sortDirection': sortDirection,
                'period': period,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosHolderListInfo OK
     * @throws ApiError
     */
    public getAptosCollectionHolderList({
        collectionId,
        page = 1,
        size = 25,
    }: {
        collectionId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/holder/list',
            query: {
                'collectionId': collectionId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosHighlightCollectionInfo OK
     * @throws ApiError
     */
    public getAptosCollectionHighLight(): CancelablePromise<AptosHighlightCollectionInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/highlight',
        });
    }

    /**
     * @returns AptosAnalyticsChartInfo OK
     * @throws ApiError
     */
    public getAptosCollectionAnalysis({
        type,
        collectionId,
        period = 'D7',
    }: {
        type: 'FLOOR_PRICE' | 'AVG_PRICE_N_VOL' | 'VOL_BY_MARKET',
        collectionId: string,
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
    }): CancelablePromise<AptosAnalyticsChartInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/analysis',
            query: {
                'type': type,
                'collectionId': collectionId,
                'period': period,
            },
        });
    }

    /**
     * @returns AptosActivityListInfo OK
     * @throws ApiError
     */
    public getAptosCollectionActivityList({
        collectionId,
        actionTypes,
        stime,
        etime,
        from = '',
        to = '',
        marketplaces,
        page = 1,
        size = 25,
    }: {
        collectionId: string,
        actionTypes?: Array<'MINT' | 'BURN' | 'TRANSFER' | 'MUTATE' | 'BIDDING' | 'CANCEL_BIDDING' | 'COLLECTION_BIDDING' | 'COLLECTION_CANCEL_BIDDING' | 'LISTING' | 'DELIST' | 'SOLD' | 'UPDATE_PRICE'>,
        stime?: number,
        etime?: number,
        from?: string,
        to?: string,
        marketplaces?: Array<string>,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/collection/activity/list',
            query: {
                'collectionId': collectionId,
                'actionTypes': actionTypes,
                'stime': stime,
                'etime': etime,
                'from': from,
                'to': to,
                'marketplaces': marketplaces,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosActivityListInfo OK
     * @throws ApiError
     */
    public getAptosActivityList({
        actionTypes,
        stime,
        etime,
        from = '',
        to = '',
        marketplaces,
        page = 1,
        size = 25,
    }: {
        actionTypes?: Array<'MINT' | 'BURN' | 'TRANSFER' | 'MUTATE' | 'BIDDING' | 'CANCEL_BIDDING' | 'COLLECTION_BIDDING' | 'COLLECTION_CANCEL_BIDDING' | 'LISTING' | 'DELIST' | 'SOLD' | 'UPDATE_PRICE'>,
        stime?: number,
        etime?: number,
        from?: string,
        to?: string,
        marketplaces?: Array<string>,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/nft/activity/list',
            query: {
                'actionTypes': actionTypes,
                'stime': stime,
                'etime': etime,
                'from': from,
                'to': to,
                'marketplaces': marketplaces,
                'page': page,
                'size': size,
            },
        });
    }

}
